import { render } from "./payroll.vue?vue&type=template&id=03bb9eae&scoped=true&ts=true"
import script from "./payroll.vue?vue&type=script&lang=ts"
export * from "./payroll.vue?vue&type=script&lang=ts"

import "./payroll.vue?vue&type=style&index=0&id=03bb9eae&lang=stylus&scoped=true"

import exportComponent from "/Users/rong.chen/data/zd/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03bb9eae"]])

export default __exports__